import {
    apiRequest,
    mappingPegawaiList,
    mappingPegawaiActive,
    mappingPegawaiInactive,
} from "../../../../../../services/adapters/master/refMesinAbsenMappingPegawaiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", mappingPegawaiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", mappingPegawaiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", mappingPegawaiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository